import { mapActions, mapMutations } from "vuex";
import serviceService from "@/services/service.js";
import localeService from "@/services/locale.js";

const Maintenance = () => import("./pages/Maintenance/Maintenance.vue");

import "@/themes/scss/vitalliance.theme.scss";
import "vue-croppa/dist/vue-croppa.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  components: {
    Maintenance,
  },
  data() {
    return { error: false, status: null };
  },
  async created() {
    this.siteInMaintenance();
    await this.getLocale();
    this.getGeneralSetting();
    this.getChatSettings();
  },
  methods: {
    ...mapMutations("auth", {
      loadStyle: "STYLES_LOADED",
      navigate: "IS_NAVIGATING",
    }),

    ...mapActions('auth', {
      getGeneralSetting: 'GET_GENERAL_SETTING'
    }),
    ...mapActions('chat', {
      getChatSettings: 'getChatSettings'
    }),
    goToVitallianceSite() {
      window.open("http://www.vitalliance.fr", "_blank");
    },
    async getLocale() {
      const vue = this;
      await localeService
        .getJson()
        .then(function(response) {
          if (response) {
            const frObj= {'fr': {...response.locale.labels,...response.locale.messages}}
            vue.$i18n.setLocaleMessage("fr", frObj.fr);
          }
        })
        .catch(function(error) {});
    },
    siteInMaintenance() {
      const vue = this;
      serviceService
        .getMaintainService()
        .then(function(response) {
          if (response.success) {
            vue.status = response.data.status;
          } else {
            vue.error = true;
          }
        })
        .catch(function(error) {
          vue.error = true;
        })
        .finally(() => {
          // Desactivating Maintenance on Error - TODO: Reactivate when server consistently return without error
          if (vue.error) {
            vue.status = true;
            vue.error = false;
          }
        });
    },
  },
  name: "App",
  watch: {
    $route(to, from) {
      this.proAccountsStyleTags = document.querySelectorAll(
        "[data-pro-account-theme]"
      );

      this.loadStyle(true);

      if (from.name !== null) {
        this.navigate(true);
      }

      // If it's not the first visiting Nagora nor hitting F5
      if (from.matched.length) {
        let found = null;

        this.proAccountsStyleTags.forEach((element) => {
          if (element.href.includes(to.params.company)) {
            found = element;
          }
        });
      }
    },
  },
};
